module.exports = __webpack_public_path__ + "img/icon_item8.10f91cc6.png";